import $ from 'jquery';

export default function modalModule() {
  const modalElement = $('.modal');
  if (modalElement.length) {
    return import(/* webpackChunkName: "modal" */ '../modal')
      .then(({ default: Modal }) => {
        const modal = new Modal();
        return modal;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
